import iconPath from '@/assets/device-icons/apple-tv-app.svg';

interface AppleTvIconProps {
  className?: string;
}

export const AppleTvIcon = ({ className = "h-5 w-5" }: AppleTvIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="Apple TV" 
      className={className}
    />
  );
};
